import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
} from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import FeeDetailsImage from "../../../../Svg/FeeDetailsImage.svg";
import { motion } from "framer-motion";

const FeeDescription = [
  {
    icon: <CheckCircle sx={{ color: "#535353" }} />,
    title: "Instant Payout",
    description:
      "Get your earnings quickly with our Stripe integrated system. No more waiting as funds are transferred directly to your account as soon as ticket sales are processed.",
  },
  {
    icon: <CheckCircle sx={{ color: "#535353" }} />,
    title: "Effortless Entry",
    description:
      "Ensure a seamless check-in experience with our digital ticketing system. Scan QR or Alphanumeric Codes and manage guest entries without any hassle.",
  },
  {
    icon: <CheckCircle sx={{ color: "#535353" }} />,
    title: "Easy Management",
    description:
      "Simplify event management with our user-friendly dashboard. Track sales, manage attendees, create Tickets, and update event details—all in one place.",
  },
];


const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: (index) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: index * 0.2, // Stagger effect
      duration: 0.6,
      ease: [0.16, 1, 0.3, 1], // Bounce ease-out
    },
  }),
};

const AffordablePricing = () => {
  return (
    <Box /* py={{ xs: 4, md: 15 }} bgcolor="#dcdada" */>
      <Container maxWidth="lg">
        <Typography variant="h4" textAlign={"center"} sx={styles.title}>
          Transparent and{" "}
          <span style={{ color: "#535353" }} className="count-shine">
            Affordable Pricing
          </span>
        </Typography>

        {/* Grid Layout */}
        <Grid container spacing={4} alignItems="center" sx={{ mt: 8 }}>
          {/* Left Column: SVG Image */}
          <Grid item xs={12} md={6}>
            <Box display="flex" justifyContent="center">
              <img
                src={FeeDetailsImage}
                alt="Pricing Illustration"
                width="80%"
              />
            </Box>
          </Grid>

          {/* Right Column: Fee Details */}
          <Grid item xs={12} md={6}>
            {FeeDescription.map((fee, index) => (
              <motion.div
                key={index}
                custom={index}
                initial="hidden"
                animate="visible"
                variants={cardVariants}
                whileHover={{ scale: 1.03 }}
                style={{ width: "100%" }}
              >
                <Card
                  sx={{
                    mb: 2,
                    borderRadius: "12px",
                    padding: "15px",
                    overflow: "hidden",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                    transition: "box-shadow 0.3s ease, transform 0.3s ease",
                    "&:hover": {
                      boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
                    },
                  }}
                >
                  <CardContent
                    sx={{ display: "flex", alignItems: "start", gap: 2 }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 45,
                        height: 45,
                        padding: 2,
                        backgroundColor: "#53535314",
                        borderRadius: "14px",
                        mb: 2,
                      }}
                    >
                      {fee.icon}
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: "18px",
                          textAlign: "justify",
                          hyphens: "auto",
                          mb: 1,
                        }}
                      >
                        {fee.title}
                      </Typography>
                      <Typography
                        variant="body1"
                        color="text.secondary"
                        sx={{
                          fontSize: "16px",
                          textAlign: {xs: "left", md: "justify"},
                          hyphens: "auto",
                          wordSpacing: "1px",
                          textWrap: "balance",
                        }}
                      >
                        {fee.description}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </motion.div>
            ))}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default AffordablePricing;

const styles = {
  title: {
    fontWeight: 700,
    // fontSize: { xs: "2rem", md: "2.5rem" },
    fontSize: { xs: 24, sm: 32, md: 40 },
  },
};
